import { Button, Input, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { FormEvent } from 'react';

import { BaseLayout } from 'components/layouts';
import { Spacing, SpacingRow, SpacingUnit } from 'components/ui';
import { DEFAULT_TEXT_CONFIG } from 'config/texts';
import { useLocalStore } from 'hooks/';
import { RegisterStore } from 'stores/local';

import s from './RegisterPage.module.scss';
import { SuccessStub } from './SuccessStub';
import { REGISTER_PAGE_TEXTS } from './texts';

const RegisterPage: React.FC = () => {
  const store = useLocalStore(() => new RegisterStore());

  const submit = React.useCallback(
    async (e: FormEvent) => {
      e.preventDefault();
      store.setError();
    },
    [store]
  );

  return (
    <BaseLayout contentClassName={s.registerPage}>
      <div className={s.registerPage__wrapper}>
        {store.error ? (
          <SuccessStub />
        ) : (
          <Spacing spacing={SpacingUnit.unit8}>
            <Spacing spacing={SpacingUnit.unit8}>
              <Typography.Title className="text-center" level={3}>
                {REGISTER_PAGE_TEXTS.WELCOME}
              </Typography.Title>
              <Spacing spacing={SpacingUnit.unit2}>
                <Typography.Text
                  className={s.registerPage__text}
                  type="secondary"
                >
                  {REGISTER_PAGE_TEXTS.PICK_PASSWORD}
                </Typography.Text>
                <Typography.Text
                  className={s.registerPage__text}
                  type="secondary"
                >
                  {REGISTER_PAGE_TEXTS.PASSWORD_REQUIREMENTS}
                </Typography.Text>
              </Spacing>
            </Spacing>
            <form onSubmit={submit} action="#">
              <Spacing spacing={SpacingUnit.unit6}>
                <Input.Password
                  placeholder={REGISTER_PAGE_TEXTS.INPUT_PASSWORD}
                  size="middle"
                />
                <Input.Password
                  placeholder={REGISTER_PAGE_TEXTS.REPEAT_PASSWORD}
                  size="middle"
                />
                <SpacingRow className={s.registerPage__button}>
                  <Button htmlType="submit">
                    {DEFAULT_TEXT_CONFIG.CONTINUE_BUTTON}
                  </Button>
                </SpacingRow>
              </Spacing>
            </form>
          </Spacing>
        )}
      </div>
    </BaseLayout>
  );
};

export default observer(RegisterPage);
